import React, { useEffect } from "react";

const LinkedInBadge = () => {
  useEffect(() => {
    // Load LinkedIn script if not already present
    if (!document.getElementById("linkedin-badge-script")) {
      const script = document.createElement("script");
      script.src = "https://platform.linkedin.com/badges/js/profile.js";
      script.async = true;
      script.defer = true;
      script.type = "text/javascript";
      script.id = "linkedin-badge-script";
      document.body.appendChild(script);

      script.onload = () => {
        if (window.LIBadge) {
          window.LIBadge.parse();
        }
      };
    } else {
      // If script already exists, force LinkedIn to parse again
      if (window.LIBadge) {
        window.LIBadge.parse();
      }
    }
  }, []);

  return (
    <div
      className="badge-base LI-profile-badge"
      data-locale="en_US"
      data-size="medium"
      data-theme="dark"
      data-type="VERTICAL"
      data-vanity="debayangshusen"
      data-version="v1"
    >
      <a
        className="badge-base__link LI-simple-link"
        href="https://in.linkedin.com/in/debayangshusen?trk=profile-badge"
      >
      </a>
    </div>
  );
};

export default LinkedInBadge;
